export default function shortenMoneyValue(num) {
  let newNum = num;
  if (typeof newNum === 'string') newNum = parseInt(newNum.replace(/,/g, ''));
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
  }).format(newNum);
}
